<div class="page-header">
  <div class="page-title-wrapper">
    <h2 class="page-title">{{ title }}</h2>
    <div class="page-underline"></div>
  </div>
</div>